<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { Table } from "../../components/Table";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import { initList, load, initDetail, loading, records, record, save, onEdit, onDelete, editing } from "./transport-document-slaughter-items.store";
  import {
    transportDocumentSlaughterItemDtoFieldsWithoutWeight,
    transportDocumentSlaughterItemDtoFieldsWithWeight,
  } from "../../utils/TableFields/transport-document-item-dto.fields";
  import SlaughterItemLotDropdown from "../../components/Business/SlaughterItemLotDropdown.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";

  export let transportDocumentId: number;
  export let withWeights: boolean;

  $: isNew = $record != null && $record.oid == 0;
  $: canSubmit = $record != null && $record.quantity > 0 && !!$record.unit && !!$record.slaughterItemId && $record.realWeight >= 0.0;

  async function onSubmit() {
    await save();
    initDetail();
    load();
  }

  function onCancel() {
    initDetail();
    load();
  }

  onMount(() => initList(transportDocumentId));
</script>

{#if !!transportDocumentId && !!$record}
  <div class="columns" style="height: unset;">
    <div class="column is-12">
      <FormLayout {canSubmit} {isNew} createButtonText="Aggiungi" on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <!--
          <div class="column is-3">
            <FormField>
              <ProductTypeDropdown name="Prodotto" required={true} phaseCode="M" bind:value={$record.productTypeId} />
            </FormField>
          </div>
          -->
          <div class="column is-6">
            <FormField>
              <SlaughterItemLotDropdown name="Prodotto" required={true} disabled={$editing} bind:value={$record.slaughterItemId} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input name="U.M." placeholder="0" required={true} bind:value={$record.unit} />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <NumberInput name="Quantità" placeholder="0" required={true} disabled={$editing} bind:value={$record.quantity} />
            </FormField>
          </div>
          {#if withWeights}
            <div class="column is-1">
              <FormField>
                <NumberInput name="Peso (orig.)" placeholder="0" required={true} bind:value={$record.realWeight} />
              </FormField>
            </div>
          {/if}
          <div class="column is-3">
            <FormField>
              <ClfDropdown
                name="Tipo lavorazione"
                placeholder="tipo lavorazione"
                schema="SLAUPROCTY"
                required={false}
                bind:value={$record.clfProcessingTypeId}
              />
            </FormField>
          </div>
        </div>
        {#if withWeights}
          <div class="columns">
            <div class="column is-12">
              <p>Se il peso viene lasciato a 0, verrà utilizzato il peso automatico, se disponibile.</p>
            </div>
          </div>
        {/if}
      </FormLayout>
    </div>
  </div>

  <Table
    loading={$loading}
    fields={withWeights ? transportDocumentSlaughterItemDtoFieldsWithWeight : transportDocumentSlaughterItemDtoFieldsWithoutWeight}
    records={$records}
    createEnabled={false}
    editEnabled={true}
    deleteEnabled={true}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
  />
{/if}
